var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BaseDateRangePicker',{attrs:{"disabled-dates":_vm.disabledDates},model:{value:(_vm.dateRange),callback:function ($$v) {_vm.dateRange=$$v},expression:"dateRange"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }